export default "__VITE_ASSET__CR09QtrG__"